// websocket.js
export default class WebSocketService {
    constructor(url) {
      this.url = url;
      this.websocket = null;
      this.reconnectInterval = 3000; // 3 seconds
      this.messageHandlers = []; // To store message handlers
      this.connect();
    }
  
    connect() {
      this.websocket = new WebSocket(this.url);
  
      this.websocket.onopen = () => {
        console.log('WebSocket连接已建立。');
      };
  
      this.websocket.onmessage = (event) => {
        // console.log('来自服务器的消息:', event.data);
        this.messageHandlers.forEach(handler => handler(event.data)); // Notify all registered handlers
      };
  
      this.websocket.onclose = (event) => {
        console.log('WebSocket连接关闭。重新连接…', event.reason);
        let data = JSON.parse(sessionStorage.getItem("shopData"));
        if(data.shop.parkId != 60037) {
          setTimeout(() => this.connect(), this.reconnectInterval);
        }
      };
  
      this.websocket.onerror = (error) => {
        console.error('WebSocket错误:', error);
        this.websocket.close(); // Trigger the onclose event
      };
    }
  
    send(message) {
      if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {
        this.websocket.send(message);
      } else {
        console.warn('WebSocket未打开。消息未发送。');
      }
    }
  
    close() {
      if (this.websocket) {
        this.websocket.close();
      }
    }
  
    onMessage(handler) {
      this.messageHandlers.push(handler); // Register a new message handler
    }
  }
  


// WEBPACK FOOTER //
// ./src/utils/websocket.js